import { useEffect, useState } from 'react';
import { useFormik } from 'formik';

import { initialValues } from './formData';

import { cleanObj } from '../../../../../shared/utils/objects';
import { ISelect, ParamEnum } from '../../../../../shared/types/shared';
import { InitialCausalityFilter } from '../../../../../shared/types/typifications/initialCausality';

import { asyncGetLabelParams } from '../../../../../services/param.service';
import { asyncGetProducts } from '../../../../../services/product.service';

export const usePqrInicialCausalityFilters = (
    onFilter?: (data: InitialCausalityFilter) => void
) => {
    const [products, setproducts] = useState<ISelect[]>([]);
    const [motives, setMotives] = useState<ISelect[]>([]);
    const [submotives1, setSubmotives1] = useState<ISelect[]>([]);
    const [submotives2, setSubmotives2] = useState<ISelect[]>([]);
    const [submotives3, setSubmotives3] = useState<ISelect[]>([]);
    const [submotives4, setSubmotives4] = useState<ISelect[]>([]);
    const [typeComplaint, setTypes] = useState<ISelect[]>([]);
    const [typesPqr, setTypesPqr] = useState<ISelect[]>([]);

    const onSubmit = (data: InitialCausalityFilter) => {
        if (onFilter) onFilter(cleanObj(data) || {});
    };

    const formik = useFormik({
        initialValues,
        onSubmit,
    });

    useEffect(() => {
        asyncGetProducts({ applyPqr: true }).then((items) =>
            setproducts(items)
        );
    }, []);

    useEffect(() => {
        asyncGetLabelParams(ParamEnum.PQR_TYPE).then((items) =>
            setTypesPqr(items.map(({ name }) => ({ id: name, name })))
        );
    }, []);

    useEffect(() => {
        asyncGetLabelParams(ParamEnum.TYPE_COMPLAINT).then((items) =>
            setTypes(items)
        );
    }, []);

    useEffect(() => {
        asyncGetLabelParams(ParamEnum.PQR_MOTIVE).then((items) =>
            setMotives(items.map(({ name }) => ({ id: name, name })))
        );
        setSubmotives1([]);
        setSubmotives2([]);
        setSubmotives3([]);
        setSubmotives4([]);
    }, []);

    useEffect(() => {
        asyncGetLabelParams(ParamEnum.PQR_SUBMOTIVE1).then((items) =>
            setSubmotives1(items.map(({ name }) => ({ id: name, name })))
        );
        setSubmotives2([]);
        setSubmotives3([]);
        setSubmotives4([]);
    }, []);

    useEffect(() => {
        asyncGetLabelParams(ParamEnum.PQR_SUBMOTIVE2).then((items) =>
            setSubmotives2(items.map(({ name }) => ({ id: name, name })))
        );
        setSubmotives3([]);
        setSubmotives4([]);
    }, []);

    useEffect(() => {
        asyncGetLabelParams(ParamEnum.PQR_SUBMOTIVE3).then((items) =>
            setSubmotives3(items.map(({ name }) => ({ id: name, name })))
        );
        setSubmotives4([]);
    }, []);

    useEffect(() => {
        asyncGetLabelParams(ParamEnum.PQR_SUBMOTIVE4).then((items) =>
            setSubmotives4(items.map(({ name }) => ({ id: name, name })))
        );
    }, []);
    return {
        formik,
        products,
        motives,
        submotives1,
        submotives2,
        submotives3,
        submotives4,
        typeComplaint,
        typesPqr,
    };
};
